import { z } from 'zod/v4';
import { getDirector, getFuldtAnsvaligeDeltagere, getWarningUpdates, getWarnings, } from '../court/index.js';
import { getRKIRegistrations } from '../customers/helpers.js';
import { CompanyStarCycle, getContactPerson, getDebtorsOnCustomer, } from '../customers/index.js';
import { PrivateStarCycle } from '../customers/index.js';
import { isDocumentFoundation } from '../documents/index.js';
import economyHelpers from '../economy/helpers/index.js';
import { getEconomyPolicy } from '../economy/helpers/policy.js';
import { calcCollectionCost } from '../economy/helpers/vouchers.js';
import { VoucherCategory, VoucherTypeIds } from '../economy/vouchers/index.js';
import { isPayment } from '../economy/vouchers/matcher.js';
import { validateAddress } from '../index.js';
import { InteractionType, ReturnReason, } from '../interactions/index.js';
import { TribunalCaseType } from '../tribunal/cases/types.js';
import { ISINCOURTUPDATESTYPES } from '../tribunal/index.js';
import { UpdateType } from '../updates/index.js';
export const NO_SUBMIT_UPDATE_ID = UpdateType.NoCourtSubmit;
export const YES_SUBMIT_UPDATE_ID = UpdateType.YesCourtSubmit;
export const NOT_SURE_SUBMIT_UPDATE_ID = UpdateType.NotSureCourtSubmit;
export var SubmitStatus;
(function (SubmitStatus) {
    SubmitStatus["Yes"] = "YES";
    SubmitStatus["No"] = "NO";
    SubmitStatus["NotSure"] = "NOT_SURE";
})(SubmitStatus || (SubmitStatus = {}));
export var SubmitToCourtError;
(function (SubmitToCourtError) {
    SubmitToCourtError["IsNotWarned"] = "IS_NOT_WARNED";
    SubmitToCourtError["CurrencyNotDKK"] = "CURRENCY_NOT_DKK";
    SubmitToCourtError["WarningWasReturned"] = "WARNING_WAS_RETURNED";
    SubmitToCourtError["AlreadyHasFoundation"] = "ALREADY_HAS_FOUNDATION";
    SubmitToCourtError["MoreThanOneDebtor"] = "MORE_THAN_ONE_DEBTOR";
    SubmitToCourtError["HasAlternativeContact"] = "HAS_ALTERNATIVE_CONTACT";
    SubmitToCourtError["EconomyContactMissing"] = "ECONOMY_CONTACT_MISSING";
    SubmitToCourtError["CreditorNameMissing"] = "CREDITOR_NAME_MISSING";
    SubmitToCourtError["CreditorAddressMissing"] = "CREDITOR_ADDRESS_MISSING";
    SubmitToCourtError["CompanyFullResponsibleParticipantMissing"] = "COMPANY_FULL_RESPONSIBLE_PARTICIPANT_MISSING";
    SubmitToCourtError["CompanyDirectorNameMissing"] = "COMPANY_DIRECTOR_NAME_MISSING";
    SubmitToCourtError["CompanyDirectorAddressMissing"] = "COMPANY_DIRECTOR_ADDRESS_MISSING";
    SubmitToCourtError["JurisdictionMissing"] = "JURISDICTION_MISSING";
    SubmitToCourtError["EconomicalSubmitThreshold"] = "ECONOMICAL_SUBMIT_THRESHOLD";
    SubmitToCourtError["SagsfremstillingMissing"] = "HAS_CASE_PRESENTATION";
    SubmitToCourtError["CaseHasExceededMaxDebtRegistrationsThreshold"] = "CASE_HAS_EXCEEDED_MAX_DEBT_REGISTRATIONS_THRESHOLD";
    SubmitToCourtError["AlreadyInCourt"] = "ALREADY_IN_COURT";
    SubmitToCourtError["AddressNotInDK"] = "ADDRESS_NOT_IN_DK";
    SubmitToCourtError["DebtorMovedAbroad"] = "DEBTOR_MOVED_ABROAD";
    SubmitToCourtError["CaseHasDeposits"] = "CASE_HAS_DEPOSITS";
    SubmitToCourtError["DebtorBankrupt"] = "DEBTOR_BANKRUPT";
    SubmitToCourtError["DebtorCompanyCeased"] = "DEBTOR_COMPANY_CEASED";
    SubmitToCourtError["DebtorDead"] = "DEBTOR_DEAD";
    SubmitToCourtError["DebtorHomeless"] = "DEBTOR_HOMELESS";
    SubmitToCourtError["ExcessiveReminderFeeImposed"] = "EXCESSIVE_REMINDER_FEE_IMPOSED";
    SubmitToCourtError["ExcessiveCollectionFeeImposed"] = "EXCESSIVE_COLLECTION_FEE_IMPOSED";
    SubmitToCourtError["ExcessiveCollectionCostImposed"] = "EXCESSIVE_COLLECTION_COST_IMPOSED";
    SubmitToCourtError["ExcessivePrincipal"] = "EXCESSIVE_PRINCIPAL";
    SubmitToCourtError["IsNotDebtor"] = "IS_NOT_DEBTOR";
})(SubmitToCourtError || (SubmitToCourtError = {}));
export const CourtSubmitConfigSchema = z.object({
    activated: z.boolean().optional(),
    economicalThreshold: z.number().nullish(),
    maxDebtRegistrations: z.number().nullish(),
    sagsfremstilling: z.string().nullish(),
    addCourtFeeToClientBilling: z.boolean().nullish(),
    addCourtDisbursementToClientBilling: z.boolean().nullish(),
    sendInfoToEconomyResponsible: z.boolean().nullish(),
    economyResponsibleUserId: z.string().nullish(),
    preventForkyndt: z.boolean().nullish(),
    preventAutDistress: z.boolean().nullish(),
    notDirectlyToCivilCourt: z.boolean().nullish(),
    reminderFeesMaximumPerPrincipal: z.boolean().nullish(),
    emailBodyFogedrekvisition: z.string().nullish(),
    includedRules: z.array(z.enum(SubmitToCourtError)).optional(),
});
export const DoNotSubmitErrors = [
    SubmitToCourtError.CurrencyNotDKK,
    SubmitToCourtError.AlreadyHasFoundation,
    SubmitToCourtError.EconomicalSubmitThreshold,
    SubmitToCourtError.CaseHasExceededMaxDebtRegistrationsThreshold,
];
export const readyToSubmit = async (validationData, config) => {
    const { case: _case, interactions, caseVouchers, customer, creditor, documents, templates, updates, tenant, fixedDistributions, conditions, } = validationData;
    let errors = [];
    // Check if warned
    const warningInteractions = getWarnings(interactions, templates);
    const warningUpdates = getWarningUpdates(updates);
    if (warningInteractions.length === 0 && warningUpdates.length === 0) {
        errors.push(SubmitToCourtError.IsNotWarned);
    }
    // Check if warning was returned
    const warningDelivered = warningInteractions.find((warning) => {
        if (warning.type === InteractionType.Email) {
            const emailDelivered = warning.events.find((event) => event.type === 'delivered');
            return emailDelivered;
        }
        else if (warning.type === InteractionType.Letter) {
            const letterNotDelivered = warning.events.find((event) => [
                ReturnReason.DENIED,
                ReturnReason.NOTDELIVERABLE,
                ReturnReason.UNKNOWNRECIPIENT,
            ].includes(event.type));
            return !letterNotDelivered;
        }
        else if (warning.type === InteractionType.Eboks) {
            const eboksDelivered = warning.events.find((event) => event.type === 'delivered');
            return eboksDelivered;
        }
        return false;
    });
    if (warningInteractions.length > 0 &&
        !warningDelivered &&
        warningUpdates.length === 0) {
        errors.push(SubmitToCourtError.WarningWasReturned);
    }
    // Check currency
    if (caseVouchers[0]?.currency !== 'DKK') {
        errors.push(SubmitToCourtError.CurrencyNotDKK);
    }
    // Check if case has deposits
    const ignoreWarningThatCaseHasDeposits = !!(tenant.settings.tribunal?.caseTypes &&
        tenant.settings.tribunal?.caseTypes[TribunalCaseType.DKBetalingspaakrav]
            ?.ignoreWarningThatCaseHasDeposits);
    if (caseVouchers.find((caseVoucher) => isPayment(caseVoucher)) &&
        !ignoreWarningThatCaseHasDeposits) {
        errors.push(SubmitToCourtError.CaseHasDeposits);
    }
    // Check for foundation
    const foundations = documents.filter(isDocumentFoundation);
    if (foundations.length > 0) {
        errors.push(SubmitToCourtError.AlreadyHasFoundation);
    }
    // Check if there is more than one debtor on case
    if (getDebtorsOnCustomer(customer).length > 1) {
        errors.push(SubmitToCourtError.MoreThanOneDebtor);
    }
    // Check if there is an alternative contact
    if (customer.users.filter((user) => user.relation === 'alternative-contact')
        .length > 0) {
        errors.push(SubmitToCourtError.HasAlternativeContact);
    }
    // Check if economy contact is registered
    if (config?.sendInfoToEconomyResponsible &&
        !config.economyResponsibleUserId) {
        errors.push(SubmitToCourtError.EconomyContactMissing);
    }
    // Check if creditor has a name
    if (!creditor.name) {
        errors.push(SubmitToCourtError.CreditorNameMissing);
    }
    // Check if creditor has an address
    if (!validateAddress(creditor.address)) {
        errors.push(SubmitToCourtError.CreditorAddressMissing);
    }
    // Check if creditor has a central register id
    if (config?.economicalThreshold &&
        config.economicalThreshold >
            -economyHelpers.overview.balance(caseVouchers, {
                filter: {
                    includeDeletedVouchers: false,
                    includeExpiredVouchers: false,
                    includeIrrecoverableVouchers: false,
                },
            })) {
        errors.push(SubmitToCourtError.EconomicalSubmitThreshold);
    }
    // Check if reminder fees are excessive
    const reminderFeesSum = -economyHelpers.overview.balanceVoucherType(caseVouchers, {
        filter: {
            includeDeletedVouchers: false,
            includeExpiredVouchers: false,
            includeIrrecoverableVouchers: false,
        },
    }, VoucherTypeIds.REMINDERFEE);
    if (config?.reminderFeesMaximumPerPrincipal
        ? reminderFeesSum >
            30000 *
                caseVouchers.filter((caseVoucher) => caseVoucher.category === VoucherCategory.PRINCIPAL).length
        : reminderFeesSum > 30000) {
        errors.push(SubmitToCourtError.ExcessiveReminderFeeImposed);
    }
    // Check if collection fees are excessive
    const collectionFeesSum = -economyHelpers.overview.balanceVoucherType(caseVouchers, {
        filter: {
            includeDeletedVouchers: false,
            includeExpiredVouchers: false,
            includeIrrecoverableVouchers: false,
        },
    }, VoucherTypeIds.COLLECTIONFEE);
    if (collectionFeesSum > 10000) {
        errors.push(SubmitToCourtError.ExcessiveCollectionFeeImposed);
    }
    // Check if principal are excessive
    const principalSum = -economyHelpers.overview.balanceCategory(caseVouchers, VoucherCategory.PRINCIPAL, {
        filter: {
            includeDeletedVouchers: false,
            includeExpiredVouchers: false,
            includeIrrecoverableVouchers: false,
        },
    });
    if (principalSum > 10000000) {
        errors.push(SubmitToCourtError.ExcessivePrincipal);
    }
    // Check if collection fees are excessive
    const collectionCostSum = -economyHelpers.overview.balanceVoucherType(caseVouchers, {
        filter: {
            includeDeletedVouchers: false,
            includeExpiredVouchers: false,
            includeIrrecoverableVouchers: false,
        },
    }, VoucherTypeIds.COLLECTIONCOST);
    let selfCollection = false;
    if (creditor.selfCollection != null) {
        selfCollection = creditor.selfCollection;
    }
    else {
        selfCollection = !!tenant.settings.selfCollection;
    }
    const calculatedCollectionCost = await calcCollectionCost(caseVouchers, documents, getEconomyPolicy(tenant, creditor, _case.economyEngine), fixedDistributions, selfCollection, conditions, tenant.countryCode);
    if (collectionCostSum > calculatedCollectionCost) {
        errors.push(SubmitToCourtError.ExcessiveCollectionCostImposed);
    }
    const debtor = getContactPerson(customer, _case);
    if (debtor?.relation !== 'debtor') {
        errors.push(SubmitToCourtError.IsNotDebtor);
    }
    if (debtor?.details.companyStatus === 'Ophørt' ||
        debtor?.details.companyStatus === 'DISSOLVED') {
        errors.push(SubmitToCourtError.DebtorCompanyCeased);
    }
    if ((debtor?.details.companyStatus &&
        [
            'UNDERKONKURS',
            'OPLØSTEFTERKONKURS',
            'UNDERTVANGSOPLØSNING',
            'TVANGSOPLØST',
            'OPLØSTEFTERFUSION',
            'OPLØSTEFTERERKLÆRING',
            'OPLØSTEFTERFRIVILLIGLIKVIDATION',
            'UNDERFRIVILLIGLIKVIDATION',
            'SLETTET',
            // New
            'UNDER_BANKRUPTCY',
            'UNDER_LIQUIDATION',
            'DISSOLVED',
        ].includes(debtor?.details.companyStatus)) ||
        (debtor?.details?.status?.stage &&
            debtor.details.status.stage !== CompanyStarCycle.Active)) {
        errors.push(SubmitToCourtError.DebtorBankrupt);
    }
    if (debtor?.details.status?.stage === PrivateStarCycle.Dead) {
        errors.push(SubmitToCourtError.DebtorDead);
    }
    if (debtor?.details.status?.stage === PrivateStarCycle.Homeless) {
        errors.push(SubmitToCourtError.DebtorHomeless);
    }
    // Check if debtor has a danish address
    const debtorCountry = debtor?.details?.address?.country;
    if (debtorCountry &&
        !['danmark', 'denmark', 'dk'].includes(debtorCountry.toLocaleLowerCase())) {
        errors.push(SubmitToCourtError.AddressNotInDK);
    }
    if (debtor?.details.movedAbroad) {
        errors.push(SubmitToCourtError.DebtorMovedAbroad);
    }
    // Check if debtors quantity of registrations is above threshold
    const rkiRegistrations = debtor && getRKIRegistrations(debtor.details);
    if (typeof config?.maxDebtRegistrations === 'number' &&
        rkiRegistrations &&
        rkiRegistrations.length > config?.maxDebtRegistrations) {
        errors.push(SubmitToCourtError.CaseHasExceededMaxDebtRegistrationsThreshold);
    }
    if (!config?.sagsfremstilling || config.sagsfremstilling.length < 50) {
        errors.push(SubmitToCourtError.SagsfremstillingMissing);
    }
    if (!debtor?.details.courtId) {
        errors.push(SubmitToCourtError.JurisdictionMissing);
    }
    if (debtor?.details.virksomhedsform &&
        selskabsformer[debtor?.details.virksomhedsform]) {
        const director = getDirector(getDebtorsOnCustomer(customer));
        if (!director?.address) {
            errors.push(SubmitToCourtError.CompanyDirectorAddressMissing);
        }
        if (!director?.name) {
            errors.push(SubmitToCourtError.CompanyDirectorNameMissing);
        }
    }
    if (debtor?.details.virksomhedsform &&
        personligtEjetVirksomhed[debtor?.details.virksomhedsform]) {
        const fuldtAnsvaligeDeltagere = getFuldtAnsvaligeDeltagere(customer.users);
        if (!(fuldtAnsvaligeDeltagere && fuldtAnsvaligeDeltagere.find((f) => f.name))) {
            errors.push(SubmitToCourtError.CompanyFullResponsibleParticipantMissing);
        }
    }
    if (updates.find((update) => ISINCOURTUPDATESTYPES.includes(update.updateTypeId))) {
        errors.push(SubmitToCourtError.AlreadyInCourt);
    }
    errors = config?.includedRules
        ? errors.filter((e) => {
            return config.includedRules.find((rule) => e === rule);
        })
        : errors;
    return {
        errors,
        status: errors.length === 0
            ? SubmitStatus.Yes
            : errors.some((error) => DoNotSubmitErrors.includes(error))
                ? SubmitStatus.No
                : SubmitStatus.NotSure,
    };
};
const selskabsformer = {
    ['Anpartsselskab']: true,
    ['Aktieselskab']: true,
    ['Iværksætterselskab']: true,
};
const personligtEjetVirksomhed = {
    ['Enkeltmandsvirksomhed']: true,
    ['Interessentskab']: true,
    ['Personligt ejet Mindre Virksomhed']: true,
};
//# sourceMappingURL=auto-submit.js.map